<script>
import constant from "@/configs/constant";
import {longDate, longDateWithJP} from "@/filters";
import systemCode from "@/mixins/systemCode";

export default {
  name: "work_reservation_information",
  mixins: [systemCode],
  props: {
    workReservation: {
      type: Object,
      default: () => {}
    },
    wasteOrServicesByWorkReservation: {
      type: Array,
      default: () => []
    },
    disableComment: {
      type: Boolean,
      default: false
    },
    displayUserCreated: {
      type: Boolean,
      default: false,
    },
    displayTimeReservationDate: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {};
  },
  computed: {
    zz_regularly_reservation_intervals() {
      return (
        this.$store.getters["options/options_tables"]
          .zz_regularly_reservation_intervals ?? []
      );
    },
  },
  methods: {
    getUserUpdated(user) {
      return user ? user.user_name : "";
    },
    getUserCreated(user) {
      // return user ? user.user_name : "";
      if(this.workReservation.user_created){
        return this.workReservation.user_created.user_name;
      }else if(this.workReservation.discharger_site_user){
        return this.workReservation.discharger_site_user.user_name;
      }
      return "";
    },

    getVendorSiteOfTreatmentName(disposalSite) {
      return disposalSite
        ? disposalSite.disposal_site_by_waste_category?.vendor_site_of_treatment?.name_abbreviated
        : "";
    },
    getVendorSiteOfTreatmentAddress(disposalSite) {
      return [
        this.$helpers.formatZipCode(disposalSite?.disposal_site_by_waste_category?.vendor_site_of_treatment?.zip),
        disposalSite?.disposal_site_by_waste_category?.vendor_site_of_treatment?.address_1,
        disposalSite?.disposal_site_by_waste_category?.vendor_site_of_treatment?.address_2,
        disposalSite?.disposal_site_by_waste_category?.vendor_site_of_treatment?.address_3,
        disposalSite?.disposal_site_by_waste_category?.vendor_site_of_treatment?.address_4,
      ].filter(x => !!x).join('')
    },
    getVendorSiteOfTreatmentTel(disposalSite) {
      return disposalSite
        ? disposalSite.disposal_site_by_waste_category?.vendor_site_of_treatment?.tel
        : "";
    },
    getReservationDateContent(reservationDate) {
      const date = reservationDate.work_reservation_date;
      const isAm = reservationDate.zz_day_of_time_zone_id === this.$constant.ZZ_DAY_OF_TIME_ZONE_ID_AM;
      const reservationType = reservationDate.zz_reservation_type?.reservation_type || '';
      const dayOfTimezone = reservationDate.zz_day_of_time_zone?.day_of_time_zone || '';
      const startTime = isAm
        ? this.findReservationStartTimeAm().system_code_value || ''
        : this.findReservationStartTimePm().system_code_value || '';
      // using moment to add time to end time, add 5 hours to startTime
      const hoursToAdd = parseFloat(this.workReservation.work_order.standard_total_hours || 0)
      const endTime = this.$moment(startTime, 'HH:mm').add(hoursToAdd, 'hours').format('HH:mm');

      let timeDisplay = '';
      const dateFormatted = this.$options.filters.longDateWithJP(date);
      const dayOfWeek = this.$options.filters.longDate(date, 'day');
      if (this.displayTimeReservationDate) {
        timeDisplay = `${startTime} ～ ${endTime} ${reservationType}`;
        timeDisplay = `<div>${dateFormatted}</div><div>（${dayOfWeek}）</div><div></div>${startTime}</div><div>～</div><div>${endTime}</div><div class="ms-2">${reservationType}</div>`
      } else {
        timeDisplay = `<div>${dateFormatted}</div><div>（${dayOfWeek}）</div><div>${dayOfTimezone}</div><div class="ms-2">${reservationType}</div>`
      }

      return timeDisplay;
    },
  }
};
</script>

<template>
  <b-card>
    <div class="mb-3 title-detail">■予約内容</div>
    <div class="mb-1 d-flex flex-wrap col-gap-5">
      <div>
        <span class="lbl-custom">予約番号：</span>
        <span>{{ workReservation.id }}</span>
      </div>
      <div>
        <span class="lbl-custom">依頼日：</span>
        <span>{{ workReservation.created_at | longDate }}</span>
      </div>
      <div>
        <span class="lbl-custom">依頼者：</span>
        <span>{{ getUserCreated() }}</span>
      </div>
    </div>
    <div class="mb-1 d-flex flex-wrap col-gap-5">
      <div>
        <span class="lbl-custom">作業予定日時</span>
      </div>
      <div>
        <div v-for="(date, index) in workReservation.reservation_dates_by_work_reservation" :key="`reservation_date_${index}`">
          <div class="d-flex mt-0 gap-1" v-if="date.zz_reservation_frequency_type_id == 1" v-html="getReservationDateContent(date)">
          </div>
        </div>
      </div>
      <div>
        <span class="lbl-custom">車両：</span>
      </div>
      <div class="ms-2">
        <div
          v-if="workReservation.car_estimates_by_work_reservation"
          v-for="item in workReservation.car_estimates_by_work_reservation"
          :key="item.id"
        >
          {{ item.estimate.invoice_product_name }}×{{ item.pivot.number_of_cars }}
        </div>
      </div>
    </div>
    <div class="mb-1">
      <div class="d-flex flex-wrap col-gap-5">
        <div>
          <span class="lbl-custom">運搬先</span>
        </div>
        <div class="mb-1" v-for="item in wasteOrServicesByWorkReservation">
          <div class="d-flex flex-wrap align-items-start">
            <div class="mr-3">
              {{
                getVendorSiteOfTreatmentName(item.waste_or_service_by_work_order.disposal_site)
              }}
            </div>
            <div class="ml-5">
              <span class="lbl-custom">住所：</span>
                {{
                  getVendorSiteOfTreatmentAddress(item.waste_or_service_by_work_order.disposal_site)
                }}
            </div>
            <div class="ml-5">
              <span class="lbl-custom">電話番号：</span>
                {{
                  getVendorSiteOfTreatmentTel(item.waste_or_service_by_work_order.disposal_site)
                }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-1">
      <span class="lbl-custom">備考（要望入力欄）：</span>
      <span v-html="workReservation.remarks"></span>
    </div>
    <div class="mb1 d-flex gap-2 flex-wrap" v-if="displayUserCreated">
      <label class="lbl-custom ">変更依頼者：</label>
      {{workReservation.user_updated ? workReservation.user_updated.user_name : ''}}
    </div>
  </b-card>
</template>

<style scoped>
.lbl-custom {
  font-weight: 600;
}

.title-detail {
  font-size: 16px;
  font-weight: 600;
}
.col-gap-5 {
  column-gap: 5rem !important;
}
</style>
